/** The agreement accepted at signup. The version marks acceptances of the placeholder text. */
export const SUBSCRIPTION_AGREEMENT = {
  document: "master-subscription-agreement",
  version: "placeholder-2026-09-28",
  title: "Master Subscription Agreement",
  path: "/legal/subscription-agreement",
} as const;
